import clsx from 'clsx'
import compact from 'lodash/compact'
import React, { FC, ReactNode } from 'react'

import { BestsellerChip } from '@Components/Chips/BestsellerChip'
import { BuyXPayForYChip } from '@Components/Chips/BuyXPayForY/BuyXPayForYChip'
import { Chip } from '@Components/Chips/Chip/Chip'
import { DiscountChip } from '@Components/Chips/DiscountChip'
import { EngravableChip } from '@Components/Chips/EngravableChip'
import { FreeDeliveryChip } from '@Components/Chips/FreeDeliveryChip'
import { NewChip } from '@Components/Chips/NewChip'
import { PersonalizableChip } from '@Components/Chips/PersonalizableChip'
import { PopularGiftChip } from '@Components/Chips/PopularGiftChip/PopularGiftChip'
import { useClub } from '@Domains/Club/Hook'
import { useTranslation } from '@Globals/Translations'

import styles from './ProductChips.module.scss'

interface Discount {
  context?: string
  percentage?: number
}

export interface ProductChipsProps {
  buyXPayForY?: { x: number, y: number }
  className?: string
  clubValue?: string
  discount?: Discount
  isBestSeller?: boolean
  isFreeDelivery?: boolean
  isNew?: boolean
  isPopularGift?: boolean
  maxNumberOfChips?: number
  personalizationTypes?: string[]
}

export const ProductChips: FC<ProductChipsProps> = ({
  buyXPayForY,
  className,
  discount,
  isBestSeller,
  isFreeDelivery,
  isNew,
  isPopularGift,
  clubValue,
  maxNumberOfChips = 2,
  personalizationTypes = [],
}) => {
  const { t } = useTranslation()
  const { isLoggedIn } = useClub()

  const isEngravable = personalizationTypes.includes('engrave')
  const isPersonalizable = personalizationTypes.length !== 0

  const children: Array<ReactNode> = [
    discount && <DiscountChip key="productchips_discount" discount={discount} size="small" />,
    // eslint-disable-next-line max-len
    isLoggedIn && clubValue && <Chip key="club_value_chip" backgroundColor="var(--royal)" size="small" textColor="var(--white)">{`${clubValue} ${t('common:CASHBACK_LABEL')}`}</Chip>,
    !isBestSeller && isNew && <NewChip key="productchips_new" size="small" />,
    !isNew && isBestSeller && <BestsellerChip key="productchips_best_seller" className={styles.bestseller} />,
    !isEngravable && isPersonalizable && <PersonalizableChip key="productchips_personalizable" className={styles.personalizable} />,
    isEngravable && <EngravableChip key="productchips_engrave" className={styles.personalizable} />,
    isFreeDelivery && <FreeDeliveryChip key="productchips_free_delivery" className={styles.freeDelivery} size="small" />,
    isPopularGift && <PopularGiftChip key="productchips_popular_gift" size="small" />,
    buyXPayForY && <BuyXPayForYChip key="productchips_buy_x_pay_for_y_chip" x={buyXPayForY.x} y={buyXPayForY.y} />,
  ]
  return (
    <div className={clsx(styles.productChips, className)}>
      {compact(children)
        .slice(0, maxNumberOfChips)}
    </div>
  )
}
